import { Config } from './core/interfaces';

export const CONFIG: Config | Record<never, never> = {};
